// extracted by mini-css-extract-plugin
module.exports = {"close":"SelectorWrapper_close__yNq3d","block":"SelectorWrapper_block__egGjk","line":"SelectorWrapper_line__pzYLP","visible":"SelectorWrapper_visible__0iLkQ"};